import * as React from 'react';
import { Box, useMediaQuery, useTheme } from "@mui/material";
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import { useNavigate } from 'react-router-dom';
import { tokens } from '../../Components/DashboardTheme/DashboardTheme';
import SectionHeading from '../../Components/SectionHeading/SectionHeading';
import Reveal from '../../Components/Reveal/Reveal';
import bagImg from '../../img/SecondPage1.webp';
import padImg from '../../img/SecondPage2.webp';
import sparringImg from '../../img/homePage2.webp';

const ACTIVITIES = [
    { index: '01', title: 'BAG', caption: 'Potenza e resistenza al sacco', image: bagImg, route: '/bagPage' },
    { index: '02', title: 'PAD', caption: 'Precisione e timing sui colpitori', image: padImg, route: '/padPage' },
    { index: '03', title: 'SPARRING', caption: 'Il ring, in sicurezza', image: sparringImg, route: '/sparringPage' },
];

export default function Activities() {
    const theme = useTheme();
    const isScreenSmall = useMediaQuery(theme.breakpoints.down('sm'));
    const navigate = useNavigate();

    return (
        <Box component="section" id="activitiesSection" sx={{ backgroundColor: tokens.ink }}>
            <SectionHeading
                kicker="Come si allena"
                title="ATTIVITÀ"
                ghost="TRAINING"
                lead="Tre pilastri, un solo obiettivo: superare i propri limiti a ogni sessione."
            />

            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: isScreenSmall ? '1fr' : 'repeat(3, 1fr)',
                    gap: { xs: 2, md: 2.5 },
                    px: { xs: 2, md: 6 },
                    pb: { xs: 6, md: 10 },
                }}
            >
                {ACTIVITIES.map((activity, i) => (
                    <Reveal key={activity.title} delay={i * 110}>
                        <Box
                            onClick={() => navigate(activity.route)}
                            role="link"
                            tabIndex={0}
                            onKeyDown={(e) => { if (e.key === 'Enter') navigate(activity.route); }}
                            sx={{
                                position: 'relative',
                                height: { xs: '46vh', md: '62vh' },
                                overflow: 'hidden',
                                cursor: 'pointer',
                                outlineOffset: 3,
                                ':hover img': { transform: 'scale(1.08)', filter: 'grayscale(0%) brightness(0.62)' },
                                ':hover .vg-card-bar': { width: '100%' },
                                ':hover .vg-card-caption': { opacity: 1, transform: 'none' },
                            }}
                        >
                            <Box
                                component="img"
                                src={activity.image}
                                alt={activity.title}
                                sx={{
                                    position: 'absolute',
                                    inset: 0,
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                    filter: 'grayscale(55%) brightness(0.45)',
                                    transition: `transform 1.1s ${tokens.ease}, filter 0.7s ${tokens.ease}`,
                                }}
                            />
                            <Box
                                aria-hidden
                                sx={{
                                    position: 'absolute',
                                    inset: 0,
                                    background: `linear-gradient(180deg, transparent 35%, ${tokens.ink}E0 100%)`,
                                }}
                            />

                            {/* Index */}
                            <Box
                                sx={{
                                    position: 'absolute',
                                    top: 20,
                                    left: 22,
                                    fontFamily: tokens.heading,
                                    fontSize: 13,
                                    letterSpacing: '0.24em',
                                    color: tokens.red,
                                }}
                            >
                                {activity.index}
                            </Box>

                            <Box sx={{ position: 'absolute', top: 20, right: 22, color: tokens.muted, display: 'flex' }}>
                                <ArrowOutwardIcon fontSize="small" />
                            </Box>

                            {/* Label */}
                            <Box sx={{ position: 'absolute', left: 22, right: 22, bottom: 24 }}>
                                <Box
                                    className="vg-card-bar"
                                    aria-hidden
                                    sx={{
                                        width: 40,
                                        height: 2,
                                        backgroundColor: tokens.red,
                                        mb: 1.75,
                                        transition: `width 0.7s ${tokens.ease}`,
                                    }}
                                />
                                <Box
                                    sx={{
                                        fontFamily: tokens.display,
                                        fontSize: { xs: 36, md: 46 },
                                        lineHeight: 1,
                                        color: tokens.white,
                                    }}
                                >
                                    {activity.title}
                                </Box>
                                <Box
                                    className="vg-card-caption"
                                    sx={{
                                        fontFamily: tokens.body,
                                        fontWeight: 300,
                                        fontSize: 14,
                                        color: tokens.muted,
                                        mt: 1,
                                        opacity: { xs: 1, md: 0 },
                                        transform: { xs: 'none', md: 'translateY(8px)' },
                                        transition: `all 0.5s ${tokens.ease}`,
                                    }}
                                >
                                    {activity.caption}
                                </Box>
                            </Box>
                        </Box>
                    </Reveal>
                ))}
            </Box>
        </Box>
    );
}
